import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("jamaica",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.4993L0 20.4993L0 4.5Z"
                fill="#007749" />
            <path
                d="M0 4.5L12 12.5L0 20.4993L0 4.5ZM24 4.5L12 12.5L24 20.5L24 4.5Z"
                fill="black" />
            <path
                d="M11.9995 11.0089L21.7638 4.5H24V5.99039L14.2357 12.4993L24 19.0082V20.4986H21.7627L11.9995 13.9897L2.23623 20.4993H0L0 19.0082L9.76323 12.5L0 5.99111L0 4.5H2.23569L11.9995 11.0089Z"
                fill="#FFB81C" />
        </svg>
    `),c=i("jamaica_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92894)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.4989L0 24.4989L0 0.5Z"
                    fill="#007749" />
                <path
                    d="M0 0.5L12 12.5L0 24.4989L0 0.5ZM24 0.5L12 12.5L24 24.5L24 0.5Z"
                    fill="black" />
                <path
                    d="M11.9995 10.2633L21.7638 0.5L24 0.5V2.73559L14.2357 12.4989L24 22.2623V24.4978H21.7627L11.9995 14.7345L2.23623 24.4989H0L0 22.2623L9.76323 12.5L0 2.73667L0 0.5L2.23569 0.5L11.9995 10.2633Z"
                    fill="#FFB81C" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92894">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Jamaica,c as JamaicaRounded};
